export class ReloadPartnerInfoAction {
  static type = '[USER] Reload Partner Info';
}
